
export default function Instagram() {
  const instagramPosts = [
    {
      id: 1,
      image: 'https://static.readdy.ai/image/d4c222fca79cec1b33ab7f1e22d0ce93/8fb0818e6cd2c8fc997c0a32f1f5853c.jpeg',
      link: 'https://www.instagram.com/lebokalgivre?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=='
    }
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-gradient-to-br from-[#F5E6D3] to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#4A7C59] mb-3 md:mb-4 px-4" style={{ fontFamily: 'Pacifico, cursive' }}>
            Suivez-nous sur Instagram 📸
          </h2>
          <p className="text-lg md:text-xl text-gray-700 px-4">
            @lebokalgivre - Découvrez nos dernières créations
          </p>
        </div>

        <div className="flex justify-center px-4">
          <a 
            href="https://www.instagram.com/lebokalgivre?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
            target="_blank"
            rel="noopener noreferrer"
            className="group relative rounded-xl md:rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 max-w-md w-full"
          >
            <img 
              src={instagramPosts[0].image}
              alt="Le Bocal Givré Instagram"
              className="w-full h-auto object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6 md:pb-8">
              <div className="text-white text-center">
                <i className="ri-instagram-line text-3xl md:text-4xl mb-2"></i>
                <p className="text-base md:text-lg font-semibold">Voir sur Instagram</p>
              </div>
            </div>
          </a>
        </div>

        <div className="text-center mt-8 md:mt-12 px-4">
          <a 
            href="https://www.instagram.com/lebokalgivre?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 md:gap-3 bg-gradient-to-r from-[#FF8F6B] to-[#FF6B9D] text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            <i className="ri-instagram-fill text-xl md:text-2xl"></i>
            Suivez @lebokalgivre
          </a>
        </div>
      </div>
    </section>
  );
}
